import { render, staticRenderFns } from "./WorkspaceSettings.vue?vue&type=template&id=7ab39a82"
import script from "./WorkspaceSettings.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports